import type { FolaPhase } from "@fola/schemas/content"
import type { LiteralKeys } from "@fola/utils/types"
import type { MemberRole } from "@fola/schemas/folaBoard"

const _folaPhase: LiteralKeys<FolaPhase> = {
	Design: "Design",
	Implement: "Implement",
	Evaluate: "Evaluate",
}

const _roles: LiteralKeys<MemberRole> = {
	guest: "Guest",
	member: "Member",
	owner: "Owner",
}

const _memberStatus = {
	add: "Add as member",
	remove: "Remove member",
}

const strings = {
	_folaPhase,
	_roles,
	abort: "Abort",
	add: "Add",
	addLearningOutcome: "Add a new Learning Outcome",
	addNewLearningOutcome: "Add your own Learning Outcome",
	addNewLearningOutcomeFromCourse: "Add a new Learning Outcome from the Course",
	bloomsTaxonomy: "Bloom's Taxonomy",
	connectedMembers: "more members are connected",
	copyLink: "Copy Link to Clipboard",
	courseDescription: "Course Description",
	courseEditor: "Course Editor",
	courseLearningOutcomes: "Course Learning Outcomes",
	courseTitle: "Course Title",
	createNew: "Create new",
	currentRole: "Current Role",
	confirmDeleteCourse: (title: string) =>
		`Are you sure you want to delete the course '${title}'? All associated sessions will be deleted as well.`,
	confirmRemoveBoard: (title: string) => `Are you sure you want to remove the session '${title}' form the course?`,
	deleteCourse: "Delete Course",
	removeCourse: "Remove Course",
	description: "Description",
	detailsSaved: "Your course details were saved.",
	detailsSavedTitle: "Course details saved",
	enterCourse: "Enter Course",
	editCourse: "Edit Course",
	editCourseMeta: "Edit course details",
	editLearningUnit: "Edit Learning Unit",
	folaBoards: "Fola Sessions",
	folaPhase: "FoLA Phase",
	inviteLink: "Invite Link",
	isOnline: "is online",
	membershipRequest: "Membership request",
	joinAsMember: "Do you want to join this board as a member?",
	joinAsMemberInquiry:
		"The owner of the course was informed. Once your request was accepted, you status will be changed to member.",
	informMemberInquiry: "A guest requested membership in your course:",
	learningOutcomes: "Learning Outcomes",
	members: "Members",
	newLearningOutcome: "New Learning Outcome",
	noLearningOutcomes: "No new Learning Outcomes for Course",
	noUsersOnline: "No users online",
	removeBoard: "Remove from course",
	selectLearningOutcome: "Select a learning outcome",
	tags: "Tags",
	title: "Title",
	titleRequiredForLearningOutcome: "To create a valid Learning Outcome, you have to fill out the title field.",
	usersOnline: (n: number) => (n > 1 ? `${n} users online` : `${n} user online`),
	waitingForServer: "Waiting for the server to create the course...",
}

export default strings
export type CourseL10nStrings = typeof strings
